import css_var from '@/utils/css-var'

export const DEFAULT_MOSAIC_SPREAD = 0.0021
export const DEFAULT_MOSAIC_OPACITY = 0.53
export const DEFAULT_SHADOW_SPREAD = 0.0021
export const DEFAULT_SHADOW_OPACITY = 0.9
export const DEFAULT_GROUP_GAP = 0.02
export const DEFAULT_TILT_AMOUNT = 0.45
export const DEFAULT_GYRO_AMOUNT = 0.45
export const DEFAULT_ATMOSPHERE_DENSITY = 0.1
export const DEFAULT_ATMOSPHERE_COLOR = css_var('--basalt').trim()
export const DEFAULT_DRIFT_AMOUNT = 0.0043
export const DEFAULT_DRIFT_SPEED = 0.15
export const DEFAULT_BREATHING_AMOUNT = 0.039
export const DEFAULT_BREATHING_SPEED = 0.85
